__turbopack_context__.v({
  "button": "ContactNextStep-module__AG91dW__button",
  "copy": "ContactNextStep-module__AG91dW__copy",
  "description": "ContactNextStep-module__AG91dW__description",
  "eyebrow": "ContactNextStep-module__AG91dW__eyebrow",
  "linkBar": "ContactNextStep-module__AG91dW__linkBar",
  "links": "ContactNextStep-module__AG91dW__links",
  "panel": "ContactNextStep-module__AG91dW__panel",
  "section": "ContactNextStep-module__AG91dW__section",
  "shell": "ContactNextStep-module__AG91dW__shell",
  "title": "ContactNextStep-module__AG91dW__title",
});
